import { Button, Col, Image, Row, Show, Typography } from '@pankod/refine-antd'
import { useNavigation, useRouterContext, useShow } from '@pankod/refine-core'
import { config } from 'config'
import { Resources } from 'consts'
import { useParams } from 'hooks'
import { PaymentSystem } from 'interfaces'

const { Title, Text } = Typography

export const PaymentSystemsShow: React.FC = () => {
  const { showUrl } = useNavigation()
  const { Link } = useRouterContext()
  const params = useParams()
  const { queryResult } = useShow<PaymentSystem>({
    resource: Resources.PAYMENT_SYSTEMS,
    id: params.id,
    metaData: {
      populate: {
        meta: {
          populate: '*',
        },
        shared_payment_system: {
          populate: ['logo'],
        },
      },
    },
  })
  const { data, isLoading } = queryResult

  const record = data?.data

  return (
    <Show
      isLoading={isLoading}
      canEdit={true}
      title={`${record?.shared_payment_system.title} Page`}
    >
      <Row gutter={48}>
        <Col span={24} md={12}>
          <Title level={5}>Meta title</Title>
          <Text>{record?.meta.title}</Text>
          <Title level={5}>Meta description</Title>
          <Text>{record?.meta.description}</Text>
          <Title level={5}>Slug</Title>
          <Text>{record?.slug}</Text>
        </Col>
        <Col span={24} md={12}>
          <Title level={4}>Original</Title>
          <Title level={5}>Title</Title>
          <Text>{record?.shared_payment_system.title}</Text>
          <Title level={5}>Slug</Title>
          <Text>{record?.shared_payment_system.slug}</Text>
          <Title level={5}>Logo</Title>
          <Image
            width={200}
            src={`${config.API_URL}${record?.shared_payment_system?.logo?.url}`}
          />
          <div style={{ marginTop: '20px' }}>
            <Link
              to={showUrl(
                Resources.SHARED_PAYMENT_SYSTEMS,
                record?.shared_payment_system.id!
              )}
              target="_blank"
            >
              <Button type="ghost">Go to original</Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Show>
  )
}
